var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_29214",
    "data-name": "Group 29214",
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96.001,
    viewBox: "0 0 96 96.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26955",
    "data-name": "Group 26955"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32574",
    "data-name": "Path 32574",
    d: "M40,0A40,40,0,1,1,0,40,40,40,0,0,1,40,0Z",
    transform: "translate(8 8)",
    fill: "#4b74f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32574_-_Outline",
    "data-name": "Path 32574 - Outline",
    d: "M40,0A40,40,0,1,0,80,40,40,40,0,0,0,40,0m0-8A48,48,0,1,1-8,40,48.055,48.055,0,0,1,40-8Z",
    transform: "translate(8 8)",
    fill: "rgba(75,116,244,0.3)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_35246",
    "data-name": "Path 35246",
    d: "M11.792,12.295a4.52,4.52,0,0,1-3.276-1.324A4.355,4.355,0,0,1,7.16,7.728,4.444,4.444,0,0,1,8.55,4.486,4.444,4.444,0,0,1,11.792,3.1,4.518,4.518,0,0,1,15.1,4.486a4.444,4.444,0,0,1,1.39,3.243,4.355,4.355,0,0,1-1.357,3.243A4.6,4.6,0,0,1,11.792,12.295Zm3.772,6.75V52.2H8.086V19.045Z",
    transform: "translate(36.175 20.354)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.fb84f11cfe486d840827ddf182858f91.svg";
export { ForwardRef as ReactComponent };